import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InputSchema } from '../../validation'
import { formActions, getFormErrors } from '../../../store/slices'
import * as yup from 'yup'
import { parseFieldName } from '../../fns'

/**
 * This custom-hook is specified for the Input section, which transparent reducer actions to dispatch functions, and custom dispatch functions for specific cases.
 * @param {Object}    actions reducer's actions
 */
const useCalcActions = (actions) => {
  const dispatch = useDispatch()
  const errors = useSelector(getFormErrors)

  const validateField = (e) => {
    const { name, value } = e.target
    try {
      yup.reach(InputSchema, name).validateSync(value)
      dispatch(formActions.removeFieldError(name))
    } catch (err) {
      dispatch(formActions.setFieldError({ name, message: err.message }))
    }
  }

  const setFieldValue = useCallback(
    (e) => {
      const { name, value } = e.target
      const fieldName = parseFieldName(name)

      dispatch(actions.modifyInput({ name: fieldName, value }))
    },
    [actions.modifyInput],
  )

  const setCalcValue = useCallback(
    (e) => {
      const { name, value } = e.target
      const fieldName = parseFieldName(name)

      dispatch(actions.modifyCalculation({ name: fieldName, value }))
    },
    [actions.modifyCalculation],
  )

  const updateCalcValue = useCallback(
    (value) => {
      const updatedValues = Object.keys(value).reduce((result, key) => {
        const fieldName = parseFieldName(key)
        result[fieldName] = value[key]

        return result
      }, {})

      dispatch(actions.updateCalculation(updatedValues))
    },
    [actions.updateCalculation],
  )

  return {
    errors,
    validateField,
    setFieldValue,
    setCalcValue,
    updateCalcValue,
    parseFieldName,
    ...actions,
  }
}

export default useCalcActions
